import { render, staticRenderFns } from "./IAPList.vue?vue&type=template&id=a4824736&"
import script from "./IAPList.vue?vue&type=script&lang=js&"
export * from "./IAPList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports